import { FC, useMemo } from 'react';
import { useCarTransportTruckList } from 'api/car-transport-truck/car-transport-truck';
import Table from 'components/Table';
import CarTransportTruckFormModal from './CarTransportTruckFormModal';
import { ColumnSetting } from 'components/Table/utils';
import { CarTransportTruckModel } from 'api/model';
import { makeNumberComparator, makeStringComparator } from 'utils/sorting';
import useModalStack from 'contexts/modal/useModalStack';
import Button from 'components/inputs/Button';

const CarTransportTruckSettings: FC = () => {
  const modalStack = useModalStack();
  const { data: trucks = [], refetch } = useCarTransportTruckList();

  const columnSettings = useMemo((): ColumnSetting<
    CarTransportTruckModel,
    object
  >[] => {
    return [
      {
        head: 'Regnr',
        width: 150,
        csvValue: (row) => row.registrationNumber,
        render: (row) => <span>{row.registrationNumber}</span>,
        sortFunction: makeStringComparator((row) => row.registrationNumber),
      },
      {
        head: 'Antal bilplatser',
        width: 200,
        csvValue: (row) => row.maxNumberOfCars?.toString() ?? '-',
        render: (row) => <span>{row.maxNumberOfCars}</span>,
        sortFunction: makeNumberComparator((row) => row.maxNumberOfCars ?? 0),
      },
    ];
  }, []);

  const openNew = () => {
    modalStack.push(
      <CarTransportTruckFormModal
        truck={null}
        onClose={() => {
          modalStack.pop();
          refetch();
        }}
      />
    );
  };

  return (
    <>
      <h1>Lastbilar (OBS: under utveckling)</h1>
      <Button onClick={openNew}>Lägg till lastbil</Button>
      <Table
        fluid
        columnSettings={columnSettings}
        rows={trucks}
        onRowClick={(row) => {
          modalStack.push(
            <CarTransportTruckFormModal
              truck={row}
              onClose={() => {
                modalStack.pop();
                refetch();
              }}
            />
          );
        }}
      />
    </>
  );
};

export default CarTransportTruckSettings;
